import { ACTION } from '@approot/global-websocket';

export enum RunningState {
  Running = 'RUNNING',
  Idle = 'IDLE'
}

type Payload = {
  error: boolean;
  warning: boolean;
  end: boolean;
  message: string;
};

export type Row = Payload & { uuid: string; info: string };

export type WSRow = {
  action: ACTION;
  uuid: string;
  payload: Payload;
};

export type AllocateTradeState = Partial<{
  uuid: string;
  runningState: RunningState;
  message: string;
}>;
